<template>
  <a-dropdown>
    <span class="action">
      <b-icon type="iconfeiyongxinxi"/>
    </span>
    <a-menu slot="overlay">
      <!-- 财务总览 -->
      <a-menu-item key="0">
        <router-link :to="{ name: 'Financial overview' }">
          <b-icon type="iconcaiwuzonglan"/>
          <span>{{ $t('custom.menu.finance.overview') }}</span>
        </router-link>
      </a-menu-item>
      <!-- 收支明细 -->
      <a-menu-item key="1">
        <router-link :to="{ name: 'Financial details' }">
          <b-icon type="iconshouzhiguanli"/>
          <span>{{ $t('custom.menu.finance.details') }}</span>
        </router-link>
      </a-menu-item>
      <!-- 我的订单 -->
      <a-menu-item key="2">
        <router-link :to="{ name: 'order' }">
          <b-icon type="icondingdanguanli"/>
          <span>{{ $t('globalHeader.feeInfo[2]') }}</span>
        </router-link>
      </a-menu-item>
      <!-- 开票管理 -->
      <a-menu-item key="3" @click="jumpStore('myInvoice')">
        <b-icon type="iconinvoice"/>
        <span>{{ $t('globalHeader.feeInfo[3]') }}</span>
      </a-menu-item>
      <!-- 能力价格 -->
      <a-menu-item key="4">
        <router-link :to="{ name: 'Application Management Index' }">
          <b-icon type="iconwodekey"></b-icon>
          <span>{{ $t('globalHeader.feeInfo[4]') }}</span>
        </router-link>
      </a-menu-item>
    </a-menu>
  </a-dropdown>
</template>

<script>
export default {
  name: 'FinanceOverview',
  data () {
    return {}
  },
  methods: {
    jumpStore (url) {
      this.$emit('jumpStore', url)
    }
  }
}
</script>

<style lang="less" scoped>
  .action {
    i {
      font-size: 20px;
    }
  }
  .ant-dropdown-menu{
    background: #303030;
    .ant-dropdown-menu-item{
      a, span, .iconfont {
        color: #fff !important;
      }
      i{
        margin-right: 8px;
      }
    }
    .ant-dropdown-menu-item-active {
      background: #464646;
      a, span, .iconfont {
        color: #4977FC !important;
      }
    }
  }
</style>
